var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "admin-tab"
  }, [_c('v-switch', {
    attrs: {
      "label": "Company vision: ".concat(_vm.companyVision ? 'on' : 'off')
    },
    model: {
      value: _vm.companyVision,
      callback: function callback($$v) {
        _vm.companyVision = $$v;
      },
      expression: "companyVision"
    }
  }), _c('admin-settings'), _c('json-editor'), _c('div', {
    staticClass: "py-5"
  }, [_vm._v(" Landing Page Config version: " + _vm._s(_vm.configVersion) + " "), _c('br'), _c('v-btn', {
    on: {
      "click": function click($event) {
        _vm.upgradeModal = true;
      }
    }
  }, [_vm._v(" Upgrade to Latest version ")])], 1), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: _vm.upgradeModal,
      callback: function callback($$v) {
        _vm.upgradeModal = $$v;
      },
      expression: "upgradeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Upgrade the landing page to the latest version?")]), _c('v-card-text', {
    staticClass: "py-4"
  }, [_vm._v(" Upgrading to the latest version will remove the product image, product name and scan result from the landing page. "), _c('br'), _vm._v(" These elements can be added back manually later on. ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.upgradeModal = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "red",
      "disabled": _vm.upgrading,
      "text": ""
    },
    on: {
      "click": _vm.upgradeLandingPageVersion
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }